<template>
  <div class="main feedback-page">
    <div class="main_r" ref="pageBody">
      <div class="page-top">
        <div class="title_line">意见反馈列表</div>

        <div class="filter-strip">
          <div class="filter-strip__fields">
            <div class="filter-field filter-field--compact">
              <label class="filter-field__label">意见内容</label>
              <el-input v-model="queryData.opinion" placeholder="输入问题" clearable size="small"></el-input>
            </div>
            <div class="filter-field filter-field--compact">
              <label class="filter-field__label">反馈内容</label>
              <el-input v-model="queryData.feedback" placeholder="输入回答" clearable size="small"></el-input>
            </div>
            <div class="filter-field filter-field--compact">
              <label class="filter-field__label">起始日期</label>
              <el-date-picker v-model="queryData.timeBegin" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" size="small"></el-date-picker>
            </div>
            <div class="filter-field filter-field--compact">
              <label class="filter-field__label">结束日期</label>
              <el-date-picker v-model="queryData.timeEnd" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" size="small"></el-date-picker>
            </div>
          </div>
          <div class="filter-strip__actions">
            <el-button type="primary" size="small" icon="el-icon-search" @click="clickQuery">查询</el-button>
            <el-button type="primary" size="small" plain icon="el-icon-refresh-left" @click="clickQueryReset">重置</el-button>
          </div>
        </div>
      </div>

      <!-- 列表 -->
      <div class="table-section" ref="tableSection">
        <div class="table-container" ref="tableContainer">
          <el-table
            :data="dataList"
            class="feedback-table"
            :height="tableHeight"
            :header-cell-style="tableHeaderStyle"
            :cell-style="tableCellStyle"
            @sort-change="handleSortChange">
            <el-table-column prop="id" label="序号" width="80" sortable="custom" align="center"></el-table-column>
            <el-table-column prop="userid" label="用户编号" min-width="120" sortable="custom" show-overflow-tooltip></el-table-column>
            <el-table-column prop="opinion" label="意见" min-width="200" sortable="custom" show-overflow-tooltip></el-table-column>
            <el-table-column prop="feedback" label="反馈" min-width="200" sortable="custom" show-overflow-tooltip></el-table-column>
            <el-table-column prop="createTime" label="创建时间" min-width="180" sortable="custom" show-overflow-tooltip class-name="col-mono"></el-table-column>
            <el-table-column prop="Operation" label="操作" width="100" fixed="right" align="center">
              <template slot-scope="scope">
                <div class="action-group">
                  <el-tooltip effect="dark" content="编辑" placement="top" :enterable="false">
                    <el-link :underline="false" type="primary" icon="el-icon-edit" @click="clickdialogEdit(scope.row)"></el-link>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <!-- 分页 -->
      <div class="pagination-wrapper">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page_no"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="page_size"
          layout="total, prev, pager, next, sizes, jumper"
          :total="dataListnum">
        </el-pagination>
      </div>
    </div>

    <!-- 编辑信息 -->
    <el-dialog title="编辑信息" :visible.sync="dialogEdit" width="26%" class="newAdd">
      <div class="addUser_body">
        <el-form ref="userMsg" :model="editData" label-width="80px">
          <el-form-item label="意见" :required=true>
            <el-input v-model="editData.opinion" placeholder="请输入意见" disabled></el-input>
          </el-form-item>
          <el-form-item label="反馈" :required=true>
            <el-input v-model="editData.feedback" placeholder="请输入反馈"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="FeedbackUpdate()" >确定</el-button>
        <el-button @click="dialogEdit = false">取消</el-button>
      </div>
    </el-dialog>
    <!-- 编辑信息 End -->
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: { },
  data () {
    return {
      activeName: 'first',
      formLabelWidth: '120px',
      queryData: {
        opinion: '',
        feedback: '',
        timeBegin: '',
        timeEnd: ''
      },
      // 列表
      dataList: [],
      dataListnum: 0,
      tableHeight: 480,
      page_no: 1,
      page_size: 10,
      sortField: '',
      sortOrder: '',
      // 编辑
      dialogEdit: false,
      editData: {
        id: '',
        opinion: '',
        feedback: ''
      }
    }
  },
  mounted () {
    this.FeedbackList()
    this.FeedbackNum()
    window.addEventListener('resize', this.onWindowResize)
    this.$nextTick(this.calcTableHeight)
    this._mainEl = this.$el.closest('.el-main')
    if (this._mainEl) {
      this._mainEl.classList.add('el-main--feedback-page')
    }
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onWindowResize)
    if (this._mainEl) {
      this._mainEl.classList.remove('el-main--feedback-page')
    }
  },
  methods: {
    tableHeaderStyle () {
      return { textAlign: 'center', background: 'var(--aptus-surface-muted)', color: 'var(--aptus-text-secondary)', fontWeight: '600' }
    },
    tableCellStyle ({ column }) {
      if (column.property === 'Operation' || column.property === 'id') {
        return { textAlign: 'center' }
      }
      return { textAlign: 'left' }
    },
    calcTableHeight () {
      var that = this
      this.$nextTick(function () {
        var container = that.$refs.tableContainer
        if (!container) return
        var height = container.clientHeight
        if (height > 0) {
          that.tableHeight = Math.max(240, Math.floor(height))
        }
      })
    },
    onWindowResize () {
      this.calcTableHeight()
    },
    handleSizeChange (val) {
      this.page_size = val
      this.FeedbackList()
      this.FeedbackNum()
    },
    handleCurrentChange (val) {
      this.page_no = val
      this.FeedbackList()
      this.FeedbackNum()
    },
    handleSortChange ({ prop, order }) {
      this.sortField = prop || ''
      this.sortOrder = order === 'ascending' ? 'asc' : (order === 'descending' ? 'desc' : '')
      this.page_no = 1
      this.FeedbackList()
      this.FeedbackNum()
    },
    clickQuery () {
      this.page_no = 1
      this.FeedbackList()
      this.FeedbackNum()
    },
    clickQueryReset () {
      this.queryData.opinion = ''
      this.queryData.feedback = ''
      this.queryData.timeBegin = ''
      this.queryData.timeEnd = ''
      this.clickQuery()
    },
    clickdialogEdit (row) {
      this.dialogEdit = true
      this.editData.id = row.id
      this.editData.opinion = row.opinion
      this.editData.feedback = row.feedback
    },
    FeedbackList: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.opinion = that.queryData.opinion
      data.feedback = that.queryData.feedback
      data.timeBegin = that.queryData.timeBegin
      data.timeEnd = that.queryData.timeEnd
      data.pageNo = that.page_no
      data.pageSize = that.page_size
      data.sortField = that.sortField
      data.sortOrder = that.sortOrder
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_FeedbackList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.code === 1) {
            that.dataList = response.data.data
          }
          that.calcTableHeight()
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    FeedbackNum: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.opinion = that.queryData.opinion
      data.feedback = that.queryData.feedback
      data.timeBegin = that.queryData.timeBegin
      data.timeEnd = that.queryData.timeEnd
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_FeedbackNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.code === 1) {
            that.dataListnum = response.data.data
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    FeedbackUpdate: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.id = that.editData.id
      data.feedback = that.editData.feedback
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_FeedbackUpdate, Qs.stringify(data))
        .then(function (response) {
          that.dialogEdit = false
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.FeedbackList()
            that.FeedbackNum()
          }
        })
        .catch(function (error) {
          console.log(error)
          that.dialogEdit = false
        })
    }
  }
}
</script>

<style lang="less" scoped>
/* ============================================================
 *  FeedbackManagement · 项目统一设计规范
 *  主色: #2563EB (深海蓝)  强调色: #FF6F00 (活力橙)
 * ============================================================ */

.feedback-page {
  /* 页面级 CSS 变量，基于全局 design-system.css */
  --aptus-primary: #2563EB;
  --aptus-primary-light: #3B82F6;
  --aptus-primary-bg: #EFF6FF;
  --aptus-accent: #FF6F00;
  --aptus-accent-bg: #FFF5EB;
  --aptus-success: #2E7D32;
  --aptus-success-bg: #EDF7ED;
  --aptus-danger: #C62828;
  --aptus-danger-bg: #FDECEC;
  --aptus-warning: #F57F17;
  --aptus-surface: #FFFFFF;
  --aptus-surface-muted: #F5F6F8;
  --aptus-border: #E2E6EC;
  --aptus-border-light: #EFF1F5;
  --aptus-text: #1A1D21;
  --aptus-text-secondary: #5E6670;
  --aptus-text-muted: #9AA3B0;

  width: 100%;
  height: calc(100vh - 88px);
  max-height: calc(100vh - 88px);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.main_r {
  height: 100%;
  padding: 16px 20px 14px;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
  box-sizing: border-box;
}

.page-top {
  flex-shrink: 0;
  margin-bottom: 12px;
}

/* 页面标题 */
.title_line {
  margin-bottom: 12px;
  font-size: 18px;
  font-weight: 700;
  color: var(--aptus-text);
  display: flex;
  align-items: center;
  gap: 10px;

  &::before {
    content: '';
    width: 4px;
    height: 22px;
    background: linear-gradient(180deg, var(--aptus-primary) 0%, var(--aptus-primary-light) 100%);
    border-radius: 2px;
  }
}

/* 筛选栏 */
.filter-strip {
  display: flex;
  align-items: flex-end;
  gap: 12px;
  padding: 10px 14px;
  background: var(--aptus-surface);
  border: 1px solid var(--aptus-border);
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(15, 26, 46, 0.04);
}

.filter-strip__fields {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 8px 12px;
  flex: 1;
  min-width: 0;
}

.filter-field--compact {
  gap: 4px;

  /deep/ .el-input,
  /deep/ .el-select,
  /deep/ .el-date-editor {
    width: 100%;
  }
}

.filter-field {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.filter-field__label {
  font-size: 12px;
  color: var(--aptus-text-secondary);
  font-weight: 500;
  line-height: 1;
  margin-bottom: 4px;
}

.filter-strip__actions {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  gap: 8px;

  /deep/ .el-button {
    margin-left: 0;
  }
}

/* 表格区域 */
.table-section {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  margin-top: 12px;
}

.table-container {
  position: relative;
  flex: 1;
  min-height: 0;
  width: 100%;
  background: var(--aptus-surface);
  border-radius: 8px;
  border: 1px solid var(--aptus-border);
  overflow: hidden;
}

/* 反馈表格 */
.feedback-table {
  /deep/ .col-mono {
    font-family: 'SF Mono', Monaco, 'Cascadia Code', Consolas, monospace;
    font-variant-numeric: tabular-nums;
    letter-spacing: -0.01em;
    color: var(--aptus-text-secondary);
  }

  /deep/ .el-table__body td {
    padding: 12px 0;
    background: var(--aptus-surface);
    border-bottom: 1px solid var(--aptus-border-light);
  }

  /deep/ .el-table__body tr:hover > td {
    background: var(--aptus-primary-bg) !important;
  }

  /deep/ .el-table__header th {
    padding: 12px 0;
    background: var(--aptus-surface-muted) !important;
    border-bottom: 1px solid var(--aptus-border);
    color: var(--aptus-text-secondary);
    font-weight: 600;
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  /deep/ .el-table__header th .cell {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
    word-break: keep-all;
    line-height: 20px;
    padding: 0 8px;
  }

  /deep/ .el-table__header th .caret-wrapper {
    flex-shrink: 0;
    margin-left: 4px;
    vertical-align: middle;
  }

  /deep/ .el-table__fixed-right-patch {
    background: var(--aptus-surface-muted);
  }

  /deep/ .el-table__fixed-header-wrapper th,
  /deep/ .el-table__fixed .el-table__fixed-header-wrapper th {
    background: var(--aptus-surface-muted) !important;
  }

  /deep/ .el-table__fixed-body-wrapper td {
    background: var(--aptus-surface);
    border-bottom: 1px solid var(--aptus-border-light);
  }

  /deep/ .el-table__fixed-body-wrapper tr:hover > td {
    background: var(--aptus-primary-bg) !important;
  }

  /deep/ thead tr th {
    border-radius: 0 !important;
  }
}

/* 操作按钮组 */
.action-group {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 2px;
  white-space: nowrap;

  .el-link {
    font-size: 15px;
    padding: 4px 5px;
    border-radius: 5px;
    transition: all 200ms ease;
    line-height: 1;

    &:hover {
      background-color: var(--aptus-primary-bg);
    }

    &.el-link--primary:hover {
      background-color: var(--aptus-primary-bg);
    }
  }
}

/* 分页 */
.pagination-wrapper {
  display: flex;
  justify-content: flex-end;
  flex-shrink: 0;
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid var(--aptus-border);
}

/* 响应式 */
@media (max-width: 1400px) {
  .filter-strip {
    flex-wrap: wrap;
  }

  .filter-strip__fields {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    width: 100%;
  }

  .filter-strip__actions {
    width: 100%;
    justify-content: flex-end;
  }
}

@media (max-width: 768px) {
  .feedback-page {
    height: calc(100vh - 72px);
  }

  .main_r {
    padding: 10px;
  }

  .filter-strip__fields {
    grid-template-columns: 1fr 1fr;
  }
}

/* 通用表单 */
.el-form-item {
  margin-bottom: 16px;
}

.jingwei {
  margin-top: -8px;

  .zuobiao{
    margin-bottom: -10px;

    p {
      margin: 0;
    }

    & p:nth-child(2){
      margin-top: -10px;
    }
  }
}

.position{
  overflow: hidden;
  height: 332px;
  background: #f7f7f7;
}

/* 弹窗样式 */
.newAdd /deep/ .el-dialog__footer {
  padding: 16px 24px;
  text-align: right;
  border-top: 1px solid var(--aptus-border-light);
}

.newAdd /deep/ .el-dialog__header {
  padding: 18px 24px;
  background: var(--aptus-surface-muted);
  border-bottom: 1px solid var(--aptus-border-light);
}

.newAdd /deep/ .el-dialog__headerbtn {
  top: 20px;
  right: 20px;
}

.newAdd /deep/ .el-dialog__title {
  font-size: 16px;
  font-weight: 600;
  color: var(--aptus-text);
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}

.addUser_body{
  padding: 0 46px 0 30px;
}

/* 按钮主题覆盖 */
/deep/ .el-button--primary {
  color: #FFF;
  background-color: var(--aptus-primary);
  border-color: var(--aptus-primary);
  font-weight: 500;
  border-radius: 6px;

  &:hover {
    background-color: var(--aptus-primary-light);
    border-color: var(--aptus-primary-light);
    box-shadow: 0 2px 8px rgba(21, 101, 192, 0.25);
  }
}

/deep/ .el-button--primary.is-plain {
  color: var(--aptus-primary);
  background: var(--aptus-primary-bg);
  border-color: #A8D0F5;

  &:hover {
    background: var(--aptus-primary);
    color: #FFF;
    border-color: var(--aptus-primary);
  }
}
</style>

<style lang="less">
.el-main--feedback-page {
  overflow: hidden;
  height: calc(100vh - 48px);
  box-sizing: border-box;
}
</style>
